<template>
  <div>
    <form-field-input
      label="Contact"
      :value="contact.full_name"
      :disabled="true"
    ></form-field-input>

    <form-field-select
      label="Lead"
      v-model="form.record_id"
      :validation-errors="validationErrors.record_id"
    >
      <option :value="null">Select a Lead</option>
      <option
        v-for="record in records"
        :key="record.id"
        :value="record.id"
      >
        <template v-if="contact.primary_record_id === record.id">{{record.property.line_1}} (Primary)</template>
        <template v-else>{{record.property.line_1}}</template>
      </option>
    </form-field-select>

    <form-field-select
      label="Follow Up Template"
      v-model="form.FUS_template_id"
      :validation-errors="validationErrors.FUS_template_id"
      @change.native="updateForm"
      show-label="description"
      :show-value="selectedTemplateDescription"
    >
      <option :value="null">Select a template</option>
      <option
        v-for="followUpTemplate in allFollowUpTemplates"
        :key="followUpTemplate.id"
        :value="followUpTemplate.id"
        :disabled="!followUpTemplate.step_count"
      >
        {{ templateLabel(followUpTemplate) }}
      </option>
    </form-field-select>

    <form-field-select-status
      label="Change Status"
      help-text="Changing status is not required"
      v-show="form.record_id"
      v-model="form.default_status_id"
      :validation-errors="validationErrors.default_status_id"
      include-no-status
    ></form-field-select-status>

    <form-field-select-user-emails
      label="Email From"
      v-model="form.user_id"
      :validation-errors="validationErrors.user_id"
    ></form-field-select-user-emails>

    <form-field-input
      label="Email From Name"
      v-model="form.from_name"
      :validation-errors="validationErrors.from_name"
    ></form-field-input>

    <form-field-select-integration-phone-number
      label="From Number"
      v-model="form.integration_phone_number_id"
      :validation-errors="validationErrors.integration_phone_number_id"
    ></form-field-select-integration-phone-number>
  </div>
</template>

<script>
  import {FormMixin} from "./forms.mixin";
  import {ENUMS} from "../services/enums";

  export default {
    name: "ContactFollowUpSequenceForm",
    props: ['formData'],
    mixins: [FormMixin],
    data() {
      return {
        form: {},
        validationErrors: {},
        isAtLimit: false,
        defaultForm: {
          contact_id: this.$store.state.activeContact.contact.id,
          record_id: this.$store.state.activeContact.contact.primary_record_id,
          user_id: null,
          from_name: '',
          FUS_template_id: null,
          integration_phone_number_id: null,
        },
      }
    },
    created() {
      // This allows you to pass in formData without an id in order to add data to the defaultForm for the the create
      this.form = (this.formData && this.formData.id) ? this.$utils.clone(this.formData) : this.$utils.clone({...this.defaultForm, ...this.formData});
    },
    computed: {
      allFollowUpTemplates() {
        return this.$store.getters.fusTemplates;
      },
      contact() {
        return this.$store.state.activeContact.contact;
      },
      records() {
        return this.$store.state.activeContact.records;
      },
      primaryRecord() {
        const record = this.$store.state.activeContact.records.find(record => record.id === this.contact.primary_record_id);
        return record ? record.property.line_1 : null;
      },
      selectedTemplateDescription() {
        if(this.form.FUS_template_id) {
          const template = this.allFollowUpTemplates.find(f => f.id === this.form.FUS_template_id);

          return template.description ? template.description : null;
        }

        return null;
      },
    },
    methods: {
      templateLabel(template) {
        if(template.step_count) {
          return template.label
        } else {
          return template.label + ' (needs steps before using)'
        }
      },
      recordOptionLabel(record) {
        let address = record.property.line_1;
        if (record.id === this.contact.primary_record_id) {
          return address + ' (Primary Record)';
        }

        return address;
      },
      updateForm() {
        if (this.form.FUS_template_id === null) {
          return;
        }

        const template = this.$store.getters.fusTemplates.find(f => f.id === this.form.FUS_template_id);
        const integrationNumber = this.$store.state.market.integrationPhoneNumbers.find(n => n.id === template.integration_phone_number_id);
        const record = this.records.find(r => r.id === this.form.record_id);
        const campaignId = record.campaign_id ;
        const campaign = this.$store.getters.campaigns.find(c => c.id === campaignId)

        // Set the email from and from name from template
        this.form.user_id = template.user_id;
        this.form.from_name = template.from_name;

        // Make sure the template record count isn't exceeded
        this.isAtLimit = template.record_count >= this.$store.getters.maxRecordsPerFusTemplate;

        // Reset the value before setting it because this field can be nullable
        this.form.integration_phone_number_id = null;
        // Set the integration number
        if(template.use_records_campaign_number && campaign && campaign.integrationPhoneNumber && this.form.record_id) {
          this.form.integration_phone_number_id = campaign.integrationPhoneNumber.id;
        } else if(integrationNumber) {
          this.form.integration_phone_number_id = integrationNumber.id
        }

        // Set default status
        this.form.default_status_id = template.default_status_id
      },
      create() {
        if(this.isAtLimit) {
          this.$buefy.toast.open({
            message: 'This follow up is at it\'s record count limit.',
            type: 'is-danger'
          });
        } else {
          return this.$api.followUp.create(this.form).then(res => {
            this.$buefy.toast.open({
              message: 'Follow Up Sequence was created',
              type: 'is-success'
            });

            return res;
          });
        }
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
